import{e as i,m as e}from"./chunk-HBP5N4FR.js";var t,s,a=i(()=>{e();t=(r=>(r.FungibleESDT="FungibleESDT",r))(t||{}),s=(n=>(n.NonFungibleESDT="NonFungibleESDT",n.SemiFungibleESDT="SemiFungibleESDT",n.MetaESDT="MetaESDT",n))(s||{})});export{t as a,s as b,a as c};
//# sourceMappingURL=chunk-LVCWBXY5.js.map
